import {resource} from '@albert-io/json-api-framework/request/builder';
import masqueradeStore from 'generic/Masquerade/Masquerade.store';

export function getClassroomsQuery(studentId) {
  return resource('student_classrooms_v1')
    .mandarkEndpoint(['students_v2', studentId, 'student_classrooms_v1'])
    .sort('name')
    .include('subjects_v2.curriculum_area_v1,teachers_v1');
}
